import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgPerson(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.9998 1.75C11.9957 1.75 8.74976 4.99594 8.74976 9C8.74976 13.0041 11.9957 16.25 15.9998 16.25C20.0038 16.25 23.2498 13.0041 23.2498 9C23.2498 4.99594 20.0038 1.75 15.9998 1.75ZM11.2498 9C11.2498 6.37665 13.3764 4.25 15.9998 4.25C18.6231 4.25 20.7498 6.37665 20.7498 9C20.7498 11.6234 18.6231 13.75 15.9998 13.75C13.3764 13.75 11.2498 11.6234 11.2498 9Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M4.38407 23.3629C3.35843 24.6962 2.71195 26.0246 2.32091 27.0192C1.93291 28.0061 1.73376 28.9516 1.52417 29.9734L3.97318 30.4757C3.9799 30.443 3.9866 30.4103 3.99327 30.3777C4.16737 29.5279 4.32673 28.75 4.64755 27.934C4.97526 27.1004 5.51628 25.9913 6.36563 24.8872C8.03601 22.7157 10.9376 20.5 15.9999 20.5C21.0621 20.5 23.9637 22.7157 25.6341 24.8872C26.4834 25.9913 27.0244 27.1005 27.3522 27.934C27.6733 28.7509 27.8294 29.5131 28.003 30.3609C28.0108 30.399 28.0186 30.4373 28.0265 30.4757L30.4755 29.9734C30.266 28.9518 30.0665 28.0054 29.6788 27.0192C29.2878 26.0246 28.6413 24.6962 27.6156 23.3629C25.536 20.6594 21.9376 18 15.9999 18C10.0621 18 6.46369 20.6594 4.38407 23.3629Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPerson);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
